import { useTheme } from '@mui/material/styles';

const NONE = {};

/**
 * The data grid's text in the selected language, from the theme
 * LocalisedMuiTheme provides (TGCLOUD-1893); empty in English.
 *
 * A grid that passes its own `localeText` REPLACES the theme's rather than
 * merging with it (MUI's resolveProps), so such a grid spreads this first:
 *
 *   localeText={{ ...gridText, noRowsLabel: t('No Records to Display') }}
 */
export default function useGridLocaleText() {
  return useTheme()?.components?.MuiDataGrid?.defaultProps?.localeText || NONE;
}
